// @ts-nocheck
import {
  FaMusic, FaRunning, FaPlane, FaFilm,
  FaUtensils, FaGamepad, FaBook, FaHiking
} from "react-icons/fa";

const interests = [
  { 
    name: "Música", 
    icon: FaMusic, 
    desc: "Exploro nuevos géneros y asisto a conciertos para inspirar creatividad y ritmo de trabajo." 
  },
  { 
    name: "Deporte", 
    icon: FaRunning, 
    desc: "Nado 2 veces/semana y practico fuerza/hipertrofia: disciplina, constancia y salud mental." 
  },
  { 
    name: "Viajar", 
    icon: FaPlane, 
    desc: "Descubro culturas y naturaleza; último viaje: Huesca (senderismo en familia)." 
  },
  { 
    name: "Cine", 
    icon: FaFilm, 
    desc: "Ciencia ficción y documentales: nuevas ideas, futuros posibles y mirada crítica." 
  },
  { 
    name: "Cocina", 
    icon: FaUtensils, 
    desc: "Recetas y batch cooking: organización, precisión y experimentación." 
  },
  { 
    name: "Videojuegos", 
    icon: FaGamepad, 
    desc: "Indie narrativo: diseño de sistemas, storytelling y UX aplicada." 
  },
  { 
    name: "Lectura", 
    icon: FaBook, 
    desc: "No ficción (tech, psicología, crecimiento). Aprendizaje continuo y foco." 
  },
  { 
    name: "Senderismo", 
    icon: FaHiking, 
    desc: "Montaña y bosque para recargar energía y mantener equilibrio." 
  },
];

export default interests;
